import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/user',
      component: ()=> import('./views/user/login.vue'),
      children: [
        {
          path: 'user',
          component: ()=> import('./views/user/login.vue'),
          meta: {title: '登录'}
        }
      ]
    },
    
    
    {
      path: '/user/entrance',
      component: () => import('./views/user/entrance.vue'),
      meta: { title: '投诉' }
    },
    {
      path: '/user/complaint',
      component: () => import('./views/user/complaint.vue'),
      meta: { title: '提交投诉' }
    },
    {
      path: '/user/complaintHistory',
      component: () => import('./views/user/complaintHistory.vue'),
      meta: { title: '投诉历史' }
    },
    {
      path: '/user/complaintResult',
      component: () => import('./views/user/complaintResult.vue'),
      meta: { title: '投诉详情' }
    },

    {
      path: '/user/QRCode',
      component: () => import('./views/user/QRCode.vue'),
      meta: { title: '注册激活' }
    },
    {
      path: '/user/bindPhoneAuthCard',
      component: () => import('./views/user/bindPhoneAuthCard.vue'),
      meta: { title: '上传身份证信息' }
    },
     
    {
      path: '/user/phoneSure',
      component: () => import('./views/user/phoneSure.vue'),
      meta: {title: '绑定手机'}  
    },
    
    {
      path: '/user/inentSim',
      component: () => import('./views/user/inentSim.vue'),
      meta: {title: '批量充值'}  
    },
    {
      path: '/user/inentPay',
      component: () => import('./views/user/inentPay.vue'),
      meta: {title: '支付'}  
    },

    {
      path: '/user/renew',
      name: 'renew',
      component: () => import('./views/user/renew.vue'),
      meta: {title: '自动续费'}
    },

    
    {
      path: '/user/loginAgent',
      component: () => import('./views/user/loginAgent.vue'),
      meta: {title: '登录'}  
    },
    {
      path: '/user/bindPhoneList',
      component: () => import('./views/user/bindPhoneList.vue'),
      meta: {title: '绑定手机列表'}  
    },
    {
      path: '/user/huodong',
      component: () => import('./views/user/huodong.vue'),
      meta: {title: '预存活动'}  
    },
    {
      path: '/user/subColloct',
      component: () => import('./views/user/subColloct.vue'),
      meta: {title: '反馈中心'}  
    },
    {
      path: '/user/huodong2',
      component: () => import('./views/user/huodong2.vue'),
      meta: {title: '预存活动'}  
    },
    {
      path: '/user/haoka17',
      component: () => import('./views/user/haoka17.vue'),
      meta: {title: '活动'}  
    },
    {
      path: '/agent/inentSim',
      component: () => import('./views/agent/inentSim.vue'),
      meta: {title: '卡板充值'} 
    },
    {
      path: '/user/subSelect',
      component: () => import('./views/user/subSelect.vue'),
      meta: {title: '反馈查询'}  
    },
    {
      path: '/user/subDetail',
      component: () => import('./views/user/subDetail.vue'),
      meta: {title: '反馈详情'}  
    },
    {
      path: '/user/jiujiu',
      component: () => import('./views/user/loginAuth.vue')
    }, 
    {
      path: '/user/bindPhone',
      component: () => import('./views/user/bindPhone.vue')
    },    
    {
      path: '/user/home',
      component: () => import('./views/user/home.vue'),
      meta: {title: '业务中心'}
    },
    {
      path: '/user/homeNew',
      component: () => import('./views/user/homeNew.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/user/homeTwo',
      component: () => import('./views/user/homeTwo.vue'),
      meta: { title: '众沃物联网' }
    },
    {
      path: '/user/queryFlux',
      component: () => import('./views/user/queryFlux.vue'),
      meta: {title: '流量查询'}
    },
    {
      path: '/user/payTest',
      component: () => import('./views/user/payTest.vue'),
      meta: {title: '测试支付'}
    },
     {
      path: '/user/cmccSheAuth',
      component: () => import('./views/user/cmccSheAuth.vue'),
      meta: {title: '实名认证'}  
    }, 
    {
      path: '/user/cuccAuth',
      component: () => import('./views/user/cuccAuth.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/cmccAuth',
      component: () => import('./views/user/cmccAuth.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/ctccAuth',
      component: () => import('./views/user/ctccAuth.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/recharge',
      name:'recharge',
      component: () => import('./views/user/recharge.vue'),
      meta: {title: '众沃物联网'}
    },
    {
      path: '/user/verified',
      component: () => import('./views/user/verified.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/haoka2',
      name:'placeOrder',
      component: () => import('./views/user/haoka2.vue'),
      meta: {title: ''}
    },
    {
      path: '/user/haokaHome',
      component: () => import('./views/user/haokaHome.vue'),
      meta: {title: '在线办理'}
    },
    {
      path: '/user/rechargeDetail',
      name: 'rechargeDetail',
      component: () => import('./views/user/rechargeDetail.vue'),
      meta: {title: '充值详情'}
    },
    {
      path: '/user/submitSuccessPage',
      name: 'submitSuccessPage',
      component: () => import('./views/user/submitSuccessPage.vue'),
      meta: {title: '提交成功'}
    },
    {
      path: '/user/orderSearch',
      name: 'orderSearch',
      component: () => import('./views/user/orderSearch.vue'),
      meta: {title: '订单查询'}
    },

    {
      path: '/user/orderSearchMy',
      name: 'orderSearchMy',
      component: () => import('./views/user/orderSearchMy.vue'),
      meta: {title: '订单查询'}
    },

    {
      path: '/user/orderSearchDetailsMy',
      name: 'orderSearchDetailsMy',
      component: () => import('./views/user/orderSearchDetailsMy.vue'),
      meta: {title: '订单查询'}
    },
    {
      path: '/user/orderSearchDetails',
      name: 'orderSearchDetails',
      component: () => import('./views/user/orderSearchDetails.vue'),
      meta: {title: '订单查询'}
    },
    {
      path: '/user/feedback',
      redirect: '/user/feedback/question',
      component: () => import('./views/user/feedback.vue'),
      children: [
          {
            path: 'list',
            component: () => import('./views/user/question.vue')
          },
          {
            path: 'question',
            component: () => import('./views/user/submitQuestion.vue')          
          }
      ],
      meta: {title: '问题反馈'}      
    },
    {
      path: '/user/buyCard',
      redirect: '/user/buyCard/buyChangeCard',
      component: () => import('./views/user/buyCard.vue'),
      children: [
          {
            path: 'buyChangeCard',
            component: () => import('./views/user/buyChangeCard.vue')
          },
          {
            path: 'buyChangeCardQuestion',
            component: () => import('./views/user/buyChangeCardQuestion.vue')          
          }
      ],
      meta: {title: '购买卡'}
    },
    {
      path: '/user/questionDetail',
      component: () => import('./views/user/questionDetail.vue'),
      meta: {title: '问题详情'}
    },
    {
      path: '/user/applyMy',
      component: () => import('./views/user/applyMy.vue'),
      meta: {title: '免费领取'}
    },

    {
      path: '/user/applyMy1',
      component: () => import('./views/user/applyMy1.vue'),
      meta: {title: '免费领取'}
    },
    {
      path: '/user/applyMy2',
      component: () => import('./views/user/applyMy2.vue'),
      meta: {title: '免费领取'}
    },
    {
      path: '/user/ctccGdAuth',
      component: () => import('./views/user/ctccGdAuth.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/applyMy3',
      component: () => import('./views/user/applyMy3.vue'),
      meta: {title: '免费领取'}
    },

    {
      path: '/user/applyChg',
      component: () => import('./views/user/applyChg.vue'),
      meta: {title: '免费领取'}
    },
    {
      path: '/user/apply1',
      component: () => import('./views/user/apply1.vue'),
      meta: {title: '免费领取'}
    },
    {
      path: '/user/openPrice',      
      component: () => import('./views/user/openPrice.vue'),
      meta: {title: '开户激活'}
    },
    {
      path: '/agent/agentBindVx',
      component: () => import('./views/agent/agentBindVx.vue'),
      meta: {title: '微信绑定'}
    },
    {
      path: '/user/simLogin',
      component: () => import('./views/user/simLogin.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/loginCucc',
      component: () => import('./views/user/loginCucc.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/loginTwo',
      component: () => import('./views/user/loginTwo.vue'),
      meta: {title: '众沃物联网'}
    },
    {
      path: '/user/loginNew',
      component: () => import('./views/user/loginNew.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/sheBeiLogin',
      component: () => import('./views/user/sheBeiLogin.vue'),
      meta: {title: '设备登录'}
    },
    {
      path: '/user/loginNo',
      component: () => import('./views/user/loginNo.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/login_New',
      component: () => import('./views/user/login_New.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/scanCodePage',
      component: () => import('./views/user/scanCodePage.vue'),
      meta: {title: '扫码'}
    },
    {
      path: '/user/simOpen',
      component: () => import('./views/user/simOpen.vue'),
      meta: {title: '优惠活动'}
    },
    {
      path: '/user/simOpens',
      component: () => import('./views/user/simOpens.vue'),
      meta: {title: '优惠活动'}
    },
    {
      path: '/user/simOpen6',
      component: () => import('./views/user/simOpen6.vue'),
      meta: {title: '优惠活动'}
    },
    {
      name:'applySalePkg',
      path: '/user/applySalePkg',
      component: () => import('./views/user/applySalePkg.vue'),
      meta: {title: '赠送金兑换卷'}  
    },
    {
      path: '/user/aliMaPay',
      component: () => import('./views/user/aliMaPay.vue'),
      meta: {title: '支付宝支付'}  
    },

    {
      path: '/user/coupon',
      name:'coupon',
      component: () => import('./views/user/coupon.vue'),
      meta: {title: '优惠券'}  
    },
    
    {
      path: '/user/bindPhoneOnely',      
      component: () => import('./views/user/bindPhoneOnely.vue'),
      meta: {title: '手机绑定'}
    },
    {
      path: '/user/chgCardQuery',      
      component: () => import('./views/user/chgCardQuery.vue'),
      meta: {title: '换卡中心'}
    },
    {
      path: '/user/userChgCard',
      name: 'userChgCard',
      component: () => import('./views/user/userChgCard.vue'),
      meta: {title: '换卡中心'}
    },
    {
      path: '/user/realName',
      name: 'realName',
      component: () => import('./views/user/realName.vue'),
      meta: {title: '实名中心'}
    },
    {
      path: '/agent/login',
      component: () => import('./views/agent/login.vue'),
      meta: {title: '商户登录'} 
    },
    {
      path: '/agent/card',
      component: () => import('./views/agent/card.vue'),
      meta: {title: '卡片管理'}
    },
    {
      path: '/agent/card2',
      component: () => import('./views/agent/card2.vue'),
      meta: {title: '套餐管理'}
    },
    {
      path: '/user/buyChangHome',
      component: () => import('./views/user/buyChangHome.vue'),
      meta: {title: '买卡列表'}
    },
    {
      path: '/user/liuliangka',
      component: () => import('./views/user/liuliangka.vue'),
      meta: {title: '商城'}
    },
    {
      path: '/user/buyCardHome',
      component: () => import('./views/user/buyCardHome.vue'),
      meta: {title: '购买商品'}
    },
    {
      path: '/agent/card3',
      component: () => import('./views/agent/card3.vue'),
      meta: {title: '套餐管理'}
    },
    {
      path: '/agent/addUser',
      component: () => import('./views/agent/addUser.vue'),
      meta: {title: '客户管理'}
    },
    {
      path: '/agent/withdrawal',
      component: () => import('./views/agent/withdrawal.vue'),
      meta: {title: '提现申请'}
    },
    {
      path: '/user/bindPhoneAuth',
      component: () => import('./views/user/bindPhoneAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/agent/home',
      component: () => import('./views/agent/home.vue'),
      meta: {title: '业务中心'}
    },
    {
      path: '/agent/secondBack',
      component: () => import('./views/agent/secondBack.vue'),
      meta: {title: '秒返设置'} 
    },
    {
      path: '/agent/distribut',
      component: () => import('./views/agent/simDistribut.vue'),
      meta: {title: '卡片分销'}   
    },
    {
      path: '/agent/notify',
      component: () => import('./views/agent/notify.vue'),
      meta: {title: '我的公告'}
    },
    {
      path: '/agent/notifyDetail',
      name: 'notifyDetail',
      component: () => import('./views/agent/notifyDetail.vue'),
      meta: {title: '公告详情'}   
    },
    {
      path: '/agent/distributRecord',
      component: () => import('./views/agent/distributRecord.vue'),
      meta: {title: '分销记录'}
    },
    {
      path: '/agent/recharge',
      component: () => import('./views/agent/recharge.vue'),
      meta: {title: '预充值'}  
    },
    {
      path: '/agent/rechargeRecord',
      component: () => import('./views/agent/rechargeRecord.vue'),
      meta: {title: '预充值记录'}  
    },
    {
      path: '/agent/onlineService',
      component: () => import('./views/agent/onlineService.vue'),
      meta: {title: '在线客服'}  
    },
    {
      path: '/user/couponToReceive',
      component: () => import('./views/user/couponToReceive.vue'),
      meta: {title: '领券中心'}  
    },
    {
      path: '/user/loadApp',
      component: () => import('./views/user/loadApp.vue'),
      meta: {title: '下载'}  
    },
    {
      path: '/user/loadApp1',
      component: () => import('./views/user/loadApp1.vue'),
      meta: {title: '下载'}  
    },
    {
      path: '/user/loginAuth',
      component: () => import('./views/user/loginAuth.vue'),
      meta: {title: '实名'}  
    },
    {
      path: '/user/loginAuthNo',
      component: () => import('./views/user/loginAuthNo.vue'),
      meta: {title: '实名'}  
    },
    {
      path: '/user/cardSetUp',
      component: () => import('./views/user/cardSetUp.vue'),
      meta: {title: '充值中心'}  
    },
    {
      path: '/user/balanceRecharge',
      component: () => import('./views/user/balanceRecharge.vue'),
      meta: {title: '余额充值'}  
    },
    {
      path: '/user/rechargeAuto',
      component: () => import('./views/user/rechargeAuto.vue'),
      meta: {title: '自动续费'}
    },
    {
      path: '/user/balanceRechargeRecord',
      component: () => import('./views/user/balanceRechargeRecord.vue'),
      meta: {title: '充值记录'}  
    },
    {
      path: '/user/notify',
      component: () => import('./views/user/notify.vue'),
      meta: {title: '我的公告'}  
    },
    {
      path: '/user/returnPostage',
      component: () => import('./views/user/returnPostage.vue'),
      meta: {title: '邮费退还'}  
    },
    {
      path: '/user/Advertisement',
      component: () => import('./components/Advertisement.vue'),
      meta: {title: '聚量广告'}  
    },
    {
      path: '/user/login2',
      component: () => import('./views/user/login2.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/user/buyCard2',
      component: () => import('./views/user/buyChangeCard2.vue'),
      meta: {
        title: '申请买卡'
      },
      
    },
    {
      path: '/agent/pkg',
      component: () => import('./views/agent/pkg.vue'),
      meta: {title: '套餐类别'} 
    },
    {
      path: '/agent/myprice',
      component: () => import('./views/agent/myprice.vue'),
      meta: {title: '佣金明细'} 
    },
    {
      path: '/agent/buysim',
      component: () => import('./views/agent/buysim.vue'),
      meta: {title: '买卡列表'} 
    },
    {
      path: '/agent/myorder',
      component: () => import('./views/agent/myorder.vue'),
      meta: {title: '订单管理'} 
    },
    {
      path: '/user/buyAgentCard',
      component: () => import('./views/user/buyAgentCard.vue'),
      meta: {title: '领卡'} 
    },
    {
      path: '/user/leyuAuth',
      component: () => import('./views/user/leyuAuth.vue'),
      meta: {title: '实名认证'} 
    },
    {
      path: '/user/orderLog',
      component: () => import('./views/user/balanceRechargeRecordApp.vue'),
      meta: {title: '套餐记录'}  
    },
    {
      path: '/user/accountLog',
      component: () => import('./views/user/balancAppAcountFlow.vue'),
      meta: {title: '充值记录'}  
    },
    {
      path: '/user/selectBindPhone',
      component: () => import('./views/user/selectBindPhone.vue'),
      meta: {title: '查询单号'}  
    },
    {
      path: '/user/AppLoad',
      component: () => import('./views/user/AppLoad.vue'),
      meta: {title: '安卓APP下载'}  
    },
    {
      path: '/user/AppLoadp',
      component: () => import('./views/user/AppLoadp.vue'),
      meta: {title: '苹果APP下载'}  
    },
    {
      path: '/user/accountInfo',
      component: () => import('./views/user/balancAppAcount.vue'),
      meta: {title: '余额记录'}  
    },  



    {
      path: '/user/haoka3',
      component: () => import('./views/user/haoka3.vue'),
      meta: {title: '靓号免费领，包邮到家'} 
    },


    {
      name:'buyOrderSearch',
      path: '/user/buyOrderSearch',
      component: () => import('./views/user/buyOrderSearch.vue'),
      meta: {title: '订单查询'} 
    },
    {
      name:'buyOrderSearchDetails',
      path: '/user/buyOrderSearchDetails',
      component: () => import('./views/user/buyOrderSearchDetails.vue'),
      meta: {title: '订单查询'} 
    },


    {
      path: '/user/AppALoad',
      component: () => import('./views/user/AppALoad.vue'),
      meta: {title: 'APP下载'}  
    },
    {
      path: '/user/uniappPay',
      component: () => import('./views/user/AppAPay.vue'),
      meta: {title: '支付'}
    },
    {
      path: '/user/AppAwPay',
      component: () => import('./views/user/AppAwPay.vue'),
      meta: {title: '支付'}
    },
    {
      path: '/user/AppASee',
      component: () => import('./views/user/AppASee.vue'),
      meta: {title: '苹果安装教程'}  
    },
    {
      path: '/user/appQian',
      component: () => import('./views/user/appQian.vue'),
      meta: {title: '签到有礼'}  
    },




    //新的界面路由
    {
      path: '/userNew/login',
      component: () => import('./views/userNew/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/userNew/bindPhone',
      component: () => import('./views/userNew/bindPhone.vue'),
      meta: { title: '绑定手机号' }
    },
    {
      path: '/userNew/diagnosis',
      component: () => import('./views/userNew/diagnosis.vue'),
      meta: { title: '智能监测' }
    },
    {
      path: '/userNew/recharge',
      name:'userNewRecharge',
      component: () => import('./views/userNew/recharge.vue'),
      meta: { title: '套餐订购' }
    },
    {
      path: '/userNew/home',
      component: () => import('./views/userNew/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/userNew/firstHome',
      component: () => import('./views/userNew/firstHome.vue'),
      meta: { title: '绑定卡号' }
    },
    {
      path: '/userNew/operation',
      component: () => import('./views/userNew/operation.vue'),
      meta: { title: '更多功能' }
    },
    {
      path: '/userNew/problem',
      component: () => import('./views/userNew/problem.vue'),
      meta: { title: '常见问题' }
    },
    {
      path: '/userNew/problemDetails',
      component: () => import('./views/userNew/problemDetails.vue'),
      meta: { title: '常见问题' }
    },
    {
      path: '/userNew/coupon',
      name:'userNewCoupon',
      component: () => import('./views/userNew/coupon.vue'),
      meta: {title: '活动余额'}  
    },
    
  ]
})
